import React, { useMemo } from 'react'
import { Button } from '../../../../components/Button/Button'
import { useNavigate } from 'react-router-dom'
import { useGetMeQuery } from '../../../../store/user/user'
import { useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { createState, IntegrationServiceId } from '../../../../common/integrations'
import { EmailConnectButton } from '../../../../components/EmailConnectButton/EmailConnectButton'
import { IntegrationIcon } from '../../../../components/IntegrationIcon'

export const InboxSuccess: React.FC = () => {
  const accountId = useAppSelector(selectAccountId)

  const navigate = useNavigate()

  const { data: currentUser } = useGetMeQuery({ accountId })

  const emailIntegration = useMemo(() => {
    return currentUser?.integrations?.find((integration) => integration.type === 'mail') ?? null
  }, [currentUser])

  if (emailIntegration) {
    return (
      <div className='d-flex flex-column gap-3 align-items-center text-center'>
        <div className='paragraph-medium'>
          You've just unlocked the powerful email AI for financial advisors. Everything's connected—time to explore your Inbox.
        </div>
        <Button variant='primary' onClick={() => navigate('/email/inbox')}>
          Go to Inbox now
        </Button>
      </div>
    )
  }

  const redirectState = createState(window.location.origin + '/dashboard/email/inbox')

  return (
    <div className='d-flex flex-column gap-3 align-items-center text-center'>
      <div className='paragraph-medium'>You've just unlocked the powerful email AI for financial advisors. First, connect your email account.</div>
      <div className='d-flex gap-3 w-100'>
        <div className='d-flex flex-1'>
          <EmailConnectButton
            serviceId={IntegrationServiceId.OUTLOOK_MAIL}
            redirectState={redirectState}
            variant='header'
            className='button-medium flex-grow-1 px-1 zocks-border-color-gray-300'
            hasOtherMailIntegration={emailIntegration !== null}
          >
            <IntegrationIcon serviceId={IntegrationServiceId.OUTLOOK_MAIL} width={16} height={16} />
            Connect Outlook Mail
          </EmailConnectButton>
        </div>
        <div className='d-flex flex-1'>
          <EmailConnectButton
            serviceId={IntegrationServiceId.GMAIL}
            redirectState={redirectState}
            variant='header'
            className='button-medium flex-grow-1 px-1 zocks-border-color-gray-300'
            hasOtherMailIntegration={emailIntegration !== null}
          >
            <IntegrationIcon serviceId={IntegrationServiceId.GMAIL} width={16} height={16} />
            Connect Gmail
          </EmailConnectButton>
        </div>
      </div>
    </div>
  )
}
